import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Utils from '../../utils';
var Toast = /*#__PURE__*/function (_Component) {
  function Toast() {
    var _this;
    _classCallCheck(this, Toast);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Toast, [].concat(args));
    _this.state = {
      visible: true
    };
    _this.timeout = null;
    _this._startCountdown = function () {
      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
      if (timeout > 0) {
        _this.timeout = setTimeout(_this._dismissNotif, timeout);
      }
    };
    _this._dismissNotif = function () {
      _this.setState({
        visible: false
      });
      setTimeout(function () {
        return _this.props.removeNotif(_this.props.data.id);
      }, 1000);
    };
    _this.transformsMessage = function (message) {
      if (!_this.props.renderColor || !_this.props.renderBold) {
        return 'Missing color or bold renderer';
      }
      var colorRegex = new RegExp(/(\{[^*]+\}[a-zA-Z\d]*)/g);
      var boldRegex = new RegExp(/(\*[^*]+\*)/g);
      var transformed = message;
      transformed = Utils.parseMarkdown(transformed, colorRegex, _this.props.renderColor);
      transformed = transformed.map(function (str) {
        return Utils.parseMarkdown(str, boldRegex, _this.props.renderBold);
      });
      return transformed;
    };
    return _this;
  }
  _inherits(Toast, _Component);
  return _createClass(Toast, [{
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      if (this.state.visible != nextState.visible) {
        if (this.props.sharedWillUpdate) {
          this.props.sharedWillUpdate(nextProps, nextState);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._startCountdown(this.props.data.timeout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.data.id !== this.props.data.id) {
        this.setState({
          visible: true
        });
        clearTimeout(this.timeout);
        this._startCountdown(this.props.data.timeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$data = this.props.data,
        message = _this$props$data.message,
        title = _this$props$data.title;
      return this.props.render({
        title: title,
        transformedMessage: this.transformsMessage(message),
        expand: this.state.visible,
        dismissHandler: this._dismissNotif
      });
    }
  }]);
}(Component);
export { Toast as default };